export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'be247be', dateTime: 1779478705414 };